/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  RemoteSessionIssuer,
  RemoteSessionIssuer$inboundSchema,
} from "./remotesessionissuer.js";

/**
 * An organization-administrator view of a remote_session_issuer: the issuer plus its associated client count and (for project-specific issuers) the owning project's name.
 */
export type OrganizationRemoteSessionIssuer = {
  /**
   * Number of non-deleted remote_session_clients registered with this issuer.
   */
  clientCount: number;
  /**
   * A remote_session_issuer record — upstream Authorization Server identity that Speakeasy speaks OAuth to.
   */
  issuer: RemoteSessionIssuer;
  /**
   * The owning project's name. Empty for organizational (project_id NULL) issuers.
   */
  projectName?: string | undefined;
};

/** @internal */
export const OrganizationRemoteSessionIssuer$inboundSchema: z.ZodMiniType<
  OrganizationRemoteSessionIssuer,
  unknown
> = z.pipe(
  z.object({
    client_count: z.int(),
    issuer: RemoteSessionIssuer$inboundSchema,
    project_name: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "client_count": "clientCount",
      "project_name": "projectName",
    });
  }),
);

export function organizationRemoteSessionIssuerFromJSON(
  jsonString: string,
): SafeParseResult<OrganizationRemoteSessionIssuer, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => OrganizationRemoteSessionIssuer$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'OrganizationRemoteSessionIssuer' from JSON`,
  );
}
